/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Inventory,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Clear Vehicle Inventory
 */
export const destroyVehicleInventory = (
    vehicleId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);

      return axiosClient<void>(
      {url: `/vehicles/${vehicleId}/inventory`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleInventoryMutationKey = () => ['destroyVehicleInventory'] as const;

export const getDestroyVehicleInventoryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventory>>, TError,DestroyVehicleInventoryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventory>>, TError,DestroyVehicleInventoryMutationVariables, TContext> => {

const mutationKey = getDestroyVehicleInventoryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicleInventory>>, DestroyVehicleInventoryMutationVariables> = (props) => {
          const {vehicleId} = props ?? {};

          return  destroyVehicleInventory(vehicleId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicleInventory>>>

    export type DestroyVehicleInventoryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyVehicleInventoryMutationVariables = {vehicleId: string}

    /**
 * @summary Clear Vehicle Inventory
 */
export const useDestroyVehicleInventory = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventory>>, TError,DestroyVehicleInventoryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicleInventory>>,
        TError,
        DestroyVehicleInventoryMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyVehicleInventoryMutationOptions(options), queryClient);
    }
    /**
 * @summary Vehicle Inventory
 */
export const vehicleInventory = (
    vehicleId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);

      return axiosClient<Inventory>(
      {url: `/vehicles/${vehicleId}/inventory`, method: 'GET', signal
    },
      );
    }




export const getVehicleInventoryQueryKey = (vehicleId: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'inventory'
    ] as const;
    }


export const getVehicleInventoryQueryOptions = <TData = Awaited<ReturnType<typeof vehicleInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleInventoryQueryKey(vehicleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleInventory>>> = ({ signal }) => vehicleInventory(vehicleId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleInventory>>, TError, TData>
}

export type VehicleInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleInventory>>>
export type VehicleInventoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicle Inventory
 */

export function useVehicleInventory<TData = Awaited<ReturnType<typeof vehicleInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleInventoryQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






